module.exports = __webpack_public_path__ + "assets/img/report-3.f2a03dd0.jpg";